import { isNull } from 'lodash-es';
import { useContext, useEffect, useState } from 'react';
import { SessionContext } from '../session-hooks';
import type { CurrentOrganisation } from './user-id-token';

export const useUserOrganizationInfo = () => {
  const { session } = useContext(SessionContext);
  const [activeOrganization, setActiveOrganization] = useState<CurrentOrganisation | null>(null);

  useEffect(() => {
    if (isNull(session)) {
      return;
    }

    setActiveOrganization(session.getUser()?.activeOrganization ?? null);

    return session?.onAccessTokenChange(
      () => {
        const activeOrg = session?.getUser()?.activeOrganization ?? null;
        setActiveOrganization(activeOrg ? { ...activeOrg } : null);
      },
    );
  }, [session]);

  return [activeOrganization] as const;
};

export const useSwitchOrganization = function () {
  const { session } = useContext(SessionContext);

  return async function (organizationId: string) {
    const authUrl = session?.getAuthServerUrl();
    await fetch(`${authUrl}realms/oneplatform/users/switch-organization`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${session?.getAccessToken()}`,
      },
      body: JSON.stringify({ id: organizationId }),
    });
    window.location.reload();
  };
};
